import { ColCommentVisibility } from "../types";

export const COLLABORATION_VISIBILITY = {
  INTERNAL: "INTERNAL" as ColCommentVisibility,
  EXTERNAL: "EXTERNAL" as ColCommentVisibility,
} as const;

export type CollaborationVisibility =
  (typeof COLLABORATION_VISIBILITY)[keyof typeof COLLABORATION_VISIBILITY];

export const COLLABORATION_VISIBILITY_COPY: Record<
  CollaborationVisibility,
  {
    analyticsEvent: string;
  }
> = {
  INTERNAL: {
    analyticsEvent: "collab-send-internal-comment",
  },
  EXTERNAL: {
    analyticsEvent: "collab-send-external-comment",
  },
};
